export const caseData = state => state.cases.data;

export const sortBy = state => state.cases.sortBy;

export const sortByOptions = state => state.cases.sortByOptions;

export const searchQuery = state => state.cases.searchQuery;



// WEBPACK FOOTER //
// ./src/store/selectors/cases.js